import { ProductListLayout } from "../types/types";
import * as layouts from "./index";

export const layoutMap: { [name: string]: ProductListLayout } = layouts;
